module.exports = __webpack_public_path__ + "img/2.25ed1003.png";